import { CreatePaymentLinkCommand, SnappPayType } from '@models/ropolo';
import { ropoloRequest } from '../axios';

export const getBankConfigurationService = async () => (await ropoloRequest.bankconfigurationList()).data;

export const snappPayBalanceDetail = async (amount: number, payType: SnappPayType) =>
  (await ropoloRequest.paymentsUserBalanceDetail(amount, payType)).data;

export const snappDirectDebitVerify = async (clientReferenceNumber?: string, vendorId?: string) =>
  (await ropoloRequest.transactionsVerifyCreate({ clientReferenceNumber, vendorId })).data;

export const postPaymentsLink = async (payload: CreatePaymentLinkCommand) =>
  (await ropoloRequest.paymentsLinkCreate(payload)).data;
